var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlayRu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Google",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 108.419 28.699",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.916,
    y1: 0.05,
    x2: -0.383,
    y2: 0.719,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#008eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#008fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00acff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00c0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00cdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00d1ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.913,
    y1: 0.5,
    x2: -1.466,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8a00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.863,
    y1: 0.177,
    x2: -0.501,
    y2: 1.952,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b11162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.188,
    y1: -0.541,
    x2: 0.421,
    y2: 0.249,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#328e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2d9571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15bd74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06d575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00de76"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_3",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 3",
    width: 108.419,
    height: 28.699,
    rx: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_221",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 221",
    d: "M5.11-5.32A4.007,4.007,0,0,1,2.2-6.471,3.971,3.971,0,0,1,1.02-9.446,3.952,3.952,0,0,1,2.2-12.415,4.018,4.018,0,0,1,5.11-13.56,3.8,3.8,0,0,1,8.2-12.069l-.787.489a2.72,2.72,0,0,0-1-.8,2.952,2.952,0,0,0-1.306-.3,2.91,2.91,0,0,0-2.188.912,3.211,3.211,0,0,0-.876,2.319,3.232,3.232,0,0,0,.876,2.325A2.9,2.9,0,0,0,5.11-6.2a2.929,2.929,0,0,0,1.222-.256,3.058,3.058,0,0,0,.912-.6V-8.683H4.514v-.882h3.72v2.874A4.009,4.009,0,0,1,5.11-5.32ZM14.393-6.2a2.645,2.645,0,0,1-2.069.87,2.645,2.645,0,0,1-2.069-.87,3.113,3.113,0,0,1-.781-2.158,3.091,3.091,0,0,1,.781-2.152,2.653,2.653,0,0,1,2.069-.865,2.653,2.653,0,0,1,2.069.865,3.091,3.091,0,0,1,.781,2.152A3.113,3.113,0,0,1,14.393-6.2Zm-3.47-.578a1.7,1.7,0,0,0,1.4.65,1.682,1.682,0,0,0,1.4-.65,2.472,2.472,0,0,0,.513-1.58,2.448,2.448,0,0,0-.513-1.574,1.688,1.688,0,0,0-1.4-.644,1.7,1.7,0,0,0-1.4.65A2.435,2.435,0,0,0,10.4-8.361,2.453,2.453,0,0,0,10.923-6.781ZM21.214-6.2a2.645,2.645,0,0,1-2.069.87,2.645,2.645,0,0,1-2.069-.87A3.113,3.113,0,0,1,16.3-8.361a3.091,3.091,0,0,1,.781-2.152,2.653,2.653,0,0,1,2.069-.865,2.653,2.653,0,0,1,2.069.865,3.091,3.091,0,0,1,.781,2.152A3.113,3.113,0,0,1,21.214-6.2Zm-3.47-.578a1.7,1.7,0,0,0,1.4.65,1.682,1.682,0,0,0,1.4-.65,2.472,2.472,0,0,0,.513-1.58,2.448,2.448,0,0,0-.513-1.574,1.688,1.688,0,0,0-1.4-.644,1.7,1.7,0,0,0-1.4.65,2.435,2.435,0,0,0-.519,1.568A2.453,2.453,0,0,0,17.744-6.781Zm8.019,3.643a4.015,4.015,0,0,1-1.3-.185A2.713,2.713,0,0,1,23.438-4l.453-.668a2.3,2.3,0,0,0,1.872.787A2.04,2.04,0,0,0,27.086-4.3a1.578,1.578,0,0,0,.525-1.306v-.823a2.5,2.5,0,0,1-.835.739,2.216,2.216,0,0,1-1.1.286,2.354,2.354,0,0,1-1.854-.8,3.174,3.174,0,0,1-.709-2.176,3.2,3.2,0,0,1,.709-2.182,2.346,2.346,0,0,1,1.854-.811,2.305,2.305,0,0,1,1.932,1.014v-.87h.894v5.592a2.253,2.253,0,0,1-.775,1.914A3.155,3.155,0,0,1,25.763-3.138Zm.131-3.053a1.991,1.991,0,0,0,1-.274,1.933,1.933,0,0,0,.721-.668V-9.649a1.9,1.9,0,0,0-.715-.662,2.014,2.014,0,0,0-1-.268,1.651,1.651,0,0,0-1.353.608,2.433,2.433,0,0,0-.495,1.586,2.419,2.419,0,0,0,.5,1.58A1.649,1.649,0,0,0,25.894-6.191Zm5.294.715h-.894v-7.954h.894Zm4.388.143a2.825,2.825,0,0,1-2.111-.841,3,3,0,0,1-.823-2.188,3.036,3.036,0,0,1,.811-2.14,2.647,2.647,0,0,1,2.027-.876A2.515,2.515,0,0,1,37.5-10.5a3.3,3.3,0,0,1,.745,2.212v.227H33.585a2.179,2.179,0,0,0,.62,1.419,1.946,1.946,0,0,0,1.455.572A2.367,2.367,0,0,0,37.437-6.8l.429.584A3.1,3.1,0,0,1,35.577-5.332Zm1.789-3.386a2.085,2.085,0,0,0-.5-1.33,1.709,1.709,0,0,0-1.4-.59,1.68,1.68,0,0,0-1.353.584,2.176,2.176,0,0,0-.531,1.336Zm6.427,3.243H42.8v-7.954H46a2.417,2.417,0,0,1,1.824.692,2.36,2.36,0,0,1,.668,1.705,2.349,2.349,0,0,1-.674,1.705A2.422,2.422,0,0,1,46-8.635H43.792Zm2.087-4.042a1.585,1.585,0,0,0,1.145-.423,1.445,1.445,0,0,0,.441-1.091,1.445,1.445,0,0,0-.441-1.091,1.585,1.585,0,0,0-1.145-.423H43.792v3.029Zm4.782,4.042h-.894v-7.954h.894Zm6.284,0h-.894v-.656a2.458,2.458,0,0,1-1.908.8,2.118,2.118,0,0,1-1.407-.513,1.729,1.729,0,0,1-.608-1.4,1.711,1.711,0,0,1,.6-1.4,2.158,2.158,0,0,1,1.413-.495,2.386,2.386,0,0,1,1.908.787V-9.386a1.078,1.078,0,0,0-.405-.894A1.636,1.636,0,0,0,54.6-10.6a2.348,2.348,0,0,0-1.765.8l-.417-.62a3.061,3.061,0,0,1,2.3-.954,2.567,2.567,0,0,1,1.61.477,1.734,1.734,0,0,1,.62,1.467Zm-2.48-.5a1.819,1.819,0,0,0,1.586-.715V-7.777a1.819,1.819,0,0,0-1.586-.715,1.486,1.486,0,0,0-1.02.352,1.159,1.159,0,0,0-.4.912,1.146,1.146,0,0,0,.4.9A1.486,1.486,0,0,0,54.465-5.976Zm3.947,2.755.143-.811a1.192,1.192,0,0,0,.489.1.927.927,0,0,0,.513-.131,1,1,0,0,0,.346-.477l.382-.87-2.409-5.819h.966l1.92,4.722,1.908-4.722h.978L60.761-4.307a1.744,1.744,0,0,1-1.693,1.169A2.427,2.427,0,0,1,58.412-3.222Z",
    transform: "translate(32.026 27.042)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "M.352.448A1.538,1.538,0,0,0,0,1.523v16.95a1.551,1.551,0,0,0,.354,1.075L.41,19.6l9.492-9.5V9.882L.41.39Z",
    transform: "translate(8.606 4.05)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "M18.556,16.781,15.39,13.615V13.39l3.166-3.16.071.039,3.752,2.13a1.163,1.163,0,0,1,0,2.214l-3.752,2.13Z",
    transform: "translate(3.118 0.542)",
    fill: "url(#linear-gradient-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "M13.336,18.567,10.119,15.35.55,24.88a1.287,1.287,0,0,0,1.577.045l11.19-6.358",
    transform: "translate(8.408 -1.283)",
    fill: "url(#linear-gradient-3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M13.336,6.622,2.127.257A1.242,1.242,0,0,0,.55.309l9.55,9.55Z",
    transform: "translate(8.408 4.189)",
    fill: "url(#linear-gradient-4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "M13.255,20.24,2.116,26.559a1.287,1.287,0,0,1-1.538,0l-.058.058.058.058a1.287,1.287,0,0,0,1.538,0l11.19-6.358Z",
    transform: "translate(8.419 -3.026)",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "M.353,29.4A1.564,1.564,0,0,1,0,28.32v.109A1.551,1.551,0,0,0,.353,29.5l.058-.058Z",
    transform: "translate(8.606 -5.907)",
    opacity: 0.07
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "M24.132,16.3,20.31,18.472l.071.071,3.752-2.156a1.358,1.358,0,0,0,.8-1.107,1.422,1.422,0,0,1-.8,1.017Z",
    transform: "translate(1.364 -1.258)",
    opacity: 0.07
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "M1.93.374,16.892,8.862a1.416,1.416,0,0,1,.8,1,1.345,1.345,0,0,0-.8-1.107L1.93.258C.875-.347,0,.155,0,1.384v.109C0,.271.875-.237,1.93.374Z",
    transform: "translate(8.604 4.189)",
    fill: "#fff",
    opacity: 0.3
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_36600",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 36600",
    d: "M.224.861V-.469a.967.967,0,0,0,.49-.147,1.112,1.112,0,0,0,.333-.532A5.6,5.6,0,0,0,1.3-2.324l.287-2.345H4.438V-.518h.427V.861H4.284V0H.805V.861ZM1.869-2.282A2.536,2.536,0,0,1,1.155-.518h2.7V-4.151H2.1ZM8.278-.427A1.553,1.553,0,0,1,7.063.084,1.553,1.553,0,0,1,5.849-.427,1.827,1.827,0,0,1,5.39-1.694a1.815,1.815,0,0,1,.458-1.263,1.558,1.558,0,0,1,1.215-.508,1.558,1.558,0,0,1,1.214.508,1.815,1.815,0,0,1,.458,1.263A1.827,1.827,0,0,1,8.278-.427ZM6.241-.767a1,1,0,0,0,.823.382.987.987,0,0,0,.819-.382,1.451,1.451,0,0,0,.3-.928,1.437,1.437,0,0,0-.3-.924A.991.991,0,0,0,7.063-3a1,1,0,0,0-.823.382,1.43,1.43,0,0,0-.3.92A1.44,1.44,0,0,0,6.241-.767Zm4.84.851A1.582,1.582,0,0,1,9.863-.424a1.8,1.8,0,0,1-.469-1.271,1.788,1.788,0,0,1,.469-1.267,1.588,1.588,0,0,1,1.218-.5,1.483,1.483,0,0,1,1.239.588l-.35.322A1.014,1.014,0,0,0,11.109-3a1.074,1.074,0,0,0-.851.364,1.372,1.372,0,0,0-.319.938,1.386,1.386,0,0,0,.319.942,1.069,1.069,0,0,0,.851.367,1.025,1.025,0,0,0,.861-.441l.35.322A1.483,1.483,0,0,1,11.081.084ZM14.2,0h-.525V-2.919h-.98v-.462h2.492v.462H14.2ZM15.68,1.323l.084-.476A.7.7,0,0,0,16.051.9a.544.544,0,0,0,.3-.077.59.59,0,0,0,.2-.28l.224-.511L15.365-3.381h.567L17.059-.609l1.12-2.772h.574L17.059.686a1.024,1.024,0,0,1-.994.686A1.425,1.425,0,0,1,15.68,1.323ZM22.113,0h-.525V-2.919H19.824V0H19.3V-3.381h2.814Zm1.575,0h-.525V-3.381h.525v1.407h1.764V-3.381h.525V0h-.525V-1.512H23.688Zm6.031-.427A1.553,1.553,0,0,1,28.5.084,1.553,1.553,0,0,1,27.29-.427a1.827,1.827,0,0,1-.458-1.267,1.815,1.815,0,0,1,.458-1.263A1.558,1.558,0,0,1,28.5-3.465a1.558,1.558,0,0,1,1.214.508,1.815,1.815,0,0,1,.459,1.263A1.827,1.827,0,0,1,29.719-.427Zm-2.037-.34a1,1,0,0,0,.823.382.987.987,0,0,0,.819-.382,1.451,1.451,0,0,0,.3-.928,1.437,1.437,0,0,0-.3-.924A.991.991,0,0,0,28.5-3a1,1,0,0,0-.823.382,1.43,1.43,0,0,0-.3.92A1.44,1.44,0,0,0,27.682-.767ZM33.362,0h-.525V-3.381h.525v1.407h1.764V-3.381h.525V0h-.525V-1.512H33.362ZM39.34,0h-.525V-.385a1.443,1.443,0,0,1-1.12.469,1.243,1.243,0,0,1-.826-.3,1.015,1.015,0,0,1-.357-.819,1,1,0,0,1,.354-.822,1.267,1.267,0,0,1,.83-.291,1.4,1.4,0,0,1,1.12.462V-2.3a.633.633,0,0,0-.238-.525.961.961,0,0,0-.616-.189,1.378,1.378,0,0,0-1.036.469l-.245-.364a1.8,1.8,0,0,1,1.351-.56,1.507,1.507,0,0,1,.945.28,1.018,1.018,0,0,1,.364.861ZM37.884-.294a1.068,1.068,0,0,0,.931-.42v-.637a1.068,1.068,0,0,0-.931-.42.872.872,0,0,0-.6.207.68.68,0,0,0-.235.536.673.673,0,0,0,.235.529A.872.872,0,0,0,37.884-.294Z",
    transform: "translate(32.999 10.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayRu);
export default __webpack_public_path__ + "static/media/google-play-ru.73bda53d307fdcfaa113df2861dfa71f.svg";
export { ForwardRef as ReactComponent };